
const m = window.require("discourse/lib/icon-library");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
